import React from "react";
import { generateCRUDRoutes } from "../../../utils/index";
import JobPosts from "./index";
import ViewJobPost from "./view";
import EditJobPost from "./edit";
import { BriefcaseBusiness } from "lucide-react";

const jobPostRoutes = [	
	generateCRUDRoutes({
		mainTitle: "Job Posts",
		basePath: "/job-posts",
		mainComponent: <JobPosts />,
	    layout: "/public",
		viewComponent: <ViewJobPost/>,
		createComponent: <EditJobPost />,
	    editComponent: <EditJobPost />,
		icon: <BriefcaseBusiness className="icon-item"/>,
	    subTitle:"Job Post",
		level:5,
		moduleId: 0,
	})
]

export default jobPostRoutes;